module.exports = __webpack_public_path__ + "img/3.abd216cf.jpg";